import React, {Dispatch, SetStateAction, useState} from "react";

function Star({
    selected,
    hover,
    onSelect,
    onHover,
    resetHover,
    index,
}: {
    selected: boolean;
    hover: boolean;
    onSelect: () => void;
    onHover: () => void;
    resetHover: () => void;
    index: number;
}) {
    return (
        <button
            data-cy={`star-${index + 1}`}
            onClick={onSelect}
            onMouseEnter={onHover}
            onMouseLeave={resetHover}
            aria-label={
                selected
                    ? `Star ${index + 1} selected. Click to deselect`
                    : `Star ${index + 1}. Click to select`
            }
            style={hover || selected ? {color: "var(--star-bg)"} : {color: "var(--tertiary)"}}
        >
            ★
        </button>
    );
}

export const StarRating = ({
    rating,
    setRating,
}: {
    rating: number;
    setRating: Dispatch<SetStateAction<number>>;
}) => {
    const [hover, setHover] = useState(0);

    return (
        <div className="stars">
            {[...Array(5)].map((n, i) => (
                <Star
                    key={i}
                    index={i}
                    selected={!hover ? i < rating : false}
                    hover={i < hover}
                    onSelect={() => setRating(i + 1)}
                    onHover={() => setHover(i + 1)}
                    resetHover={() => setHover(0)}
                />
            ))}
        </div>
    );
};
